module.exports = __webpack_public_path__ + "img/fa-brands-400.0cb5a5c0.svg";